import { render, staticRenderFns } from "./ModalSaveDocumentTemplate.vue?vue&type=template&id=7aa67d2f&scoped=true"
import script from "./ModalSaveDocumentTemplate.vue?vue&type=script&lang=js"
export * from "./ModalSaveDocumentTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa67d2f",
  null
  
)

export default component.exports